export const REJECT_REASON = {
    EXPERIENCE: 1,
    NATIONALITY: 2,
    RECENT_ENROLLMENT: 3,
}